import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useTheme, type Theme } from '@/hooks/use-theme'
import { CheckIcon, MoonIcon, SettingsIcon, SunRoomIcon } from '@/lib/icons'
import { motion } from 'motion/react'

export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme()

  const themeOptions: { value: Theme; label: string; icon: typeof SunRoomIcon }[] = [
    { value: 'light', label: 'Light', icon: SunRoomIcon },
    { value: 'dark', label: 'Dark', icon: MoonIcon },
    { value: 'system', label: 'System', icon: SettingsIcon },
  ]

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="relative h-9 w-9 rounded-full"
          aria-label="Toggle theme"
        >
          <motion.div
            key={resolvedTheme}
            initial={{ scale: 0.5, rotate: -90, opacity: 0 }}
            animate={{ scale: 1, rotate: 0, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 200, damping: 15 }}
          >
            {resolvedTheme === 'dark' ? (
              <MoonIcon className="h-5 w-5" />
            ) : (
              <SunRoomIcon className="h-5 w-5" />
            )}
          </motion.div>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-36">
        {themeOptions.map(option => {
          const Icon = option.icon
          const isSelected = theme === option.value
          return (
            <DropdownMenuItem
              key={option.value}
              onClick={() => setTheme(option.value)}
              className="cursor-pointer"
            >
              <Icon className="mr-2 h-4 w-4" />
              <span className="flex-1">{option.label}</span>
              {isSelected && (
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ type: 'spring', stiffness: 500, damping: 25 }}
                >
                  <CheckIcon className="text-primary h-4 w-4" />
                </motion.div>
              )}
            </DropdownMenuItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
